import WashdayClientSingleton from './WashdayClientSingleton';
import { IIntercomSession } from '../interfaces/Intercom';

/**
 * Fetches a fresh Intercom messenger JWT from the backend.
 * Pass `existingJwt` to let the backend reuse a still-valid token
 * instead of issuing a new one unnecessarily.
 */
export const fetchIntercomMessengerToken = async (existingJwt?: string): Promise<IIntercomSession | null> => {
  try {
    const res = await WashdayClientSingleton.getInstance().intercom.getMessengerToken({
      intercomJwt: existingJwt,
      platform: 'web'
    });
    if (res?.data?.data) {
      return res.data.data as IIntercomSession;
    }
    return null;
  } catch (e) {
    console.log('ERROR fetchIntercomMessengerToken', e);
    return null;
  }
};
